import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TitleWithTextValue } from 'components/title-with-text-value';
import React, { FC } from 'react';

const useStyles = makeStyles((theme: any) => ({
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: "1.2rem",
    color: theme.palette.primary.darker,
    borderBottom: "1px solid lightgray",
    padding: "8px 0px"
  },
}));

type dataPolicy = {
  text: string;
  value: string | number;
  plus: boolean;
  minus: boolean;
  result: boolean;
  spaceLeft: boolean;
};

type BalanceInfoProps = {
  title: string;
  data: dataPolicy[];
};

export const BalanceInfo: FC<BalanceInfoProps> = ({ title, data }) => {
  const classes = useStyles();
  return (
    <Box style={{ display: "flex", flexDirection: "column" }}>
      <Typography
        className={classes.titleContainer}
      >
        {title}
      </Typography>

      <Box style={{ padding: "1rem" }}>
        {data.map((row) => (
          <TitleWithTextValue
            key={`${row.text}-${row.value}`}
            title={row.text}
            value={row.value}
            valueIsMoney
            direction="row"
            justifyContent="space-between"
            valueLeftAdorment={row.plus ? "+" : undefined}
            spacing={1}
          />
        ))}
      </Box>
    </Box>
  );
};
